import React from "react";

import { useAppContext } from "@app/helpers/hooks";

import { BasicLayout } from "../../../components/basic-layout";
import { Authentication } from "../../../components/modals/authentication";
import { redirect } from "../../../utils/window";

interface Props {
  from_expired_link?: boolean;
}
export const ForgotPasswordApp: React.FC<Props> = ({
  from_expired_link = false
}) => {
  const { urlBuilder } = useAppContext();

  return (
    <BasicLayout>
      <Authentication
        onClose={() => redirect(urlBuilder.home())}
        opening_view="ForgotPassword"
        from_expired_link={from_expired_link}
      />
    </BasicLayout>
  );
};
